import React from "react";
import { connect } from "react-redux";
import Alert from "react-s-alert";
import AppRoute from "../AppRoutes.jsx";
import { setPath, setFiles, setFilePath, setSelectedCompany, setCompanyId, setLabels } from "../actions/homeActions";
import { setCompanyList, setBillingPlan } from "../actions/companyActions.js";
import { setProfileDetail, loginEmail } from "../actions/authActions";
import { setCurrentPeriod, setComparePeriod, setFilterPeriod } from "../actions/businessActions";
import { API_URLS } from "../constants/API_URLS";
import { sendRequest } from "../util/httpRequest";
import { apiRenamer, hideLoader } from "../util/genericFunctions";
import { HTTP_METHODS, KEYS_COOKIES, KEYS_STORAGE } from "../constants/enums";
import { STATUS_CODES } from "../constants/statusCodes";
import { removeCookieItem } from "../util/cookieHelper";
import { setItem } from "../util/storageHelper.js";

const AppContainer = (props) =>
    <AppRoute {...props} />

const mapStateToProps = (state) => ({
  selectedCompany: state.home.selectedCompany || "",
  companyId: state.home.companyId || "",
  loginEmail: state.auth.loginEmail || "",
})

const mapDispatchToProps = (dispatch, props) => ({
  setPathName: function (path) {
    dispatch(setPath(path))
  },
  clearFiles: function () {
    dispatch(setFiles([]))
  },
  setFilePath: function (filePath) {
    dispatch(setFilePath(filePath))
  },
  setSelectedCompany: function (company) {
    dispatch(setSelectedCompany(company))
  },
  setCompanyId: function (companyId) {
    dispatch(setCompanyId(companyId))
  },
  setCompanyList: function (companyList) {
    dispatch(setCompanyList(companyList.sort()))
  },
  getProfileDetail: function () {
    let option = {}
    option.headers = {}
    sendRequest(API_URLS.PROFILE, HTTP_METHODS.GET, {}, option, (err, res) => {
      if (err === null) {
        dispatch(setProfileDetail(res.data))
      }
    })
  },
  forgotPassword: function (email, response, error) {
    let option = {}
    option.headers = {}
    const forgotPasswordUrl = apiRenamer(API_URLS.FORGOT_PASSWORD, ["email"], [email])
    sendRequest(forgotPasswordUrl, HTTP_METHODS.POST, {}, option, (err, res) => {
      if (err === null) {
        response(res)
      } else {
        error(err)
      }
    })
  },
  login: function (loginRequest, response, error) {
    let option = {}
    option.headers = {}
    dispatch(loginEmail(loginRequest.email))
    sendRequest(API_URLS.LOGIN, HTTP_METHODS.POST, loginRequest, option, (err, res) => {
      if (err === null) {
        dispatch(loginEmail(loginRequest.email))
        dispatch(setProfileDetail({}))
        response(res)
      } else {
        error(err)
      }
    })
  },
  signup: function (signupRequest, response, error) {
    let option = {}
    option.headers = {}
    sendRequest(API_URLS.SIGNUP, HTTP_METHODS.POST, signupRequest, option, (err, res) => {
      if (err === null) {
        if (res.status === STATUS_CODES.CREATED) {
          response(res.data)
        }
      } else {
        error(err)
      }
    })
  },
  verifyEmail: function (token, id, response, error) {
    let option = {}
    option.headers = {}
    const verifyEmailUrl = apiRenamer(API_URLS.VERIFY_EMAIL, ["token", "id"], [token, id]);
    sendRequest(verifyEmailUrl, HTTP_METHODS.GET, {}, option, (err, res) => {
      if (err === null) {
        response(res)
      } else {
        error(err)
      }
    })
  },
  resendVerifyEmail: function (email) {
    let option = {};
    option.headers = {};
    const resendVerifyEmailUrl = apiRenamer(API_URLS.RESEND_VERIFY_EMAIL, ["email"], [email]);
    sendRequest(resendVerifyEmailUrl, HTTP_METHODS.GET, {}, option, (err, res) => {
      if (err === null) {
        Alert.success("Verification email sent successfully");
      } else {
        Alert.error(err.data);
      }
    })
  },
  getLabels: function (object) {
    let option = {}
    option.headers = {}
    sendRequest(API_URLS.GET_LABELS, HTTP_METHODS.POST, object, option, (err, res) => {
      if (err === null) {
        dispatch(setLabels(res.data))
      }
    })
  },
  createCompany: function (object, response, error) {
    let option = {}
    option.headers = {}
    sendRequest(API_URLS.CREATE_COMPANY, HTTP_METHODS.POST, object, option, (err, res) => {
      if (err === null) {
        response(res)
      } else {
        error(err)
      }
    })
  },
  createClient: function (object, response, error) {
    let option = {}
    option.headers = {}
    sendRequest(API_URLS.CREATE_CLIENT, HTTP_METHODS.POST, object, option, (err, res) => {
      if (err === null) {
        response(res)
      } else {
        error(err)
      }
    })
  },
  logout: function () {
    dispatch(setFiles([]))
    dispatch(setCurrentPeriod({}))
    dispatch(setComparePeriod({}))
    dispatch(setFilterPeriod({}))
    removeCookieItem(KEYS_COOKIES.SESSION)
    localStorage.clear()
  },
  startPaymentSession: function (plan, response, error) {
    let option = {}
    option.headers = {}
    sendRequest(API_URLS.START_SESSION, HTTP_METHODS.POST, plan, option, (err, res) => {
      if (err === null) {
        setItem(KEYS_STORAGE.PLAN, plan)
        response(res)
      } else {
        error(err)
      }
    })
  },
  subscribeToPlan: function (id, response, error) {
    let option = {}
    option.headers = {}
    sendRequest(API_URLS.SUBSCRIBE_TO_PLAN, HTTP_METHODS.POST, { id }, option, (err, res) => {
      if (err === null) {
        response(res)
      } else {
        error(err)
      }
    })
  },
  activateCompany: function (object, response, error) {
    let option = {}
    option.headers = {}
    sendRequest(API_URLS.GST_ACTIVATE_COMPANY, HTTP_METHODS.POST, object, option, (err, res) => {
      if (err === null) {
        response(res)
      } else {
        error(err)
      }
    })
  },
  isGSTActivate: function (legalName, response) {
    let option = {}
    option.headers = {}
    sendRequest(API_URLS.GST_IS_ACTIVE, HTTP_METHODS.POST, { legalName }, {}, (err, { data }) => {
      if (err) {
        Alert.error(err.data.message)
      } else {
        response(data)
      }
    })
  },
  resetPassword: function (password, response) {
    let option = {}
    option.headers = {}
    sendRequest(API_URLS.RESET_PASSWORD, HTTP_METHODS.POST, { password }, {}, (err, { data }) => {
      if (err) {
        Alert.error(err.data)
      } else {
        response(data)
      }
    })
  },
  updateUser: function (object, response) {
    let option = {}
    option.headers = {}
    sendRequest(API_URLS.UPDATE_USER_PROFILE, HTTP_METHODS.POST, object, {}, (err, { data }) => {
      if (err) {
        hideLoader()
        Alert.error(err.data)
      } else {
        response(data)
      }
    })
  },
  getBillingPlan: function (permId) {
    let option = {}
    option.headers = {}
    const billingPlanUrl = apiRenamer(API_URLS.BILLING_PLAN, ["permId"], [permId])
    sendRequest(billingPlanUrl, HTTP_METHODS.GET, {}, option, (err, res) => {
      if (err === null) {
        dispatch(setBillingPlan(res.data))
      } else {
        dispatch(setBillingPlan({}))
      }
    })
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer)
